import PartnerCustomerStatsDTO from 'models/dto/partnerCustomerStatsDTO';
import GlobalDataCache from 'models/globalDataCache/globalDataCache';
import PartnerCustomerStats from 'models/partnerCustomerStats';
import User from 'models/user';
import { mapFromTenant } from './tenantMapping';
import { mapFromUser } from './userMapping';

export function mapFromPartnerCustomerStats(
  dto: PartnerCustomerStatsDTO,
  cache: GlobalDataCache,
): PartnerCustomerStats {
  const stats = new PartnerCustomerStats();
  stats.newTenant = dto.newTenant ? mapFromTenant(dto.newTenant) : undefined;
  stats.userCount = dto.userCount ?? 0;
  stats.userLogins = dto.userLogins?.map((u) => mapFromUser(u, cache) as User) ?? [];
  stats.mgmtLicenseCount = dto.mgmtLicenseCount ?? 0;

  return stats;
}
